<template>
  <div class="trainer-tab p-4">
    <template v-if="!loaded">
      <div class="text-center">
        <icon icon="loading" class="loading-icon" />
      </div>
    </template>

    <template v-else>
      <template v-if="!!company">
        <p class="m-0">This event is trained by:</p>
        <p>
          <a
            v-for="(trainer, i) in event.trainers"
            :key="i"
            :href="company.url"
            class="text-primary font-weight-bold"
            >{{ trainer.name }}</a
          >
        </p>
        <TrainerBio :company="company" />
      </template>

      <template v-else>
        <div v-for="(trainer, i) in trainers" :key="i">
          <hr v-if="i > 0" />
          <h4>
            <strong>{{ trainer.name }}</strong>
          </h4>
          <p>
            {{ trainer.company }}
            <span v-if="!!trainer.email"><br />{{ trainer.email }}</span>
            <span v-if="!!trainer.phone"><br />{{ trainer.phone }}</span>
          </p>
          <div v-if="!!trainer.bio" v-html="trainer.bio"></div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import TrainerBio from "components/partials/Companies/TrainerBio";
export default {
  components: { TrainerBio },

  props: {
    event: { type: Object, required: true },
  },

  data() {
    return {
      company: null,
      trainers: [],
      loaded: false,
    };
  },

  watch: {
    event(model) {
      this.loaded = false;
      this.load();
    },
  },

  methods: {
    load() {
      this.axios
        .get(this.route("catalog.event.trainer", { event: this.event.id }))
        .then((response) => {
          if (_.has(response.data, "company")) {
            this.company = response.data.company;
            this.trainers = [];
          } else if (_.has(response.data, "trainers")) {
            this.trainers = response.data.trainers;
            this.company = null;
          }

          this.loaded = true;
        });
    },
  },

  mounted() {
    this.load();
  },
};
</script>